import React, { useState, useRef, useEffect } from "react";
import "./Geofence.css";
import { Button, Input } from ".";
import { buttonClasses } from "./theme";

const Geofence = ({ onCoordinatesChange, factoryCoordinates: initialCoordinates = [], readOnly = false, noExtraField=false }) => {
	const [map, setMap] = useState(null);
	const [drawingManager, setDrawingManager] = useState(null);
	const [factoryCoordinates, setFactoryCoordinates] = useState([]);
	const [location, setLocation] = useState("");
	const [latLngInput, setLatLngInput] = useState({ lat: "", lng: "" });
	const mapRef = useRef(null);
	const autocompleteRef = useRef(null);
	const currentPolygonRef = useRef(null); // Ref to store the current polygon
	const markerRef = useRef(null);  // Ref for the marker
    const [errors, setErrors]= useState(false)

	const initMap = () => {
		if (!window.google || !window.google.maps || !window.google.maps.places) return;

		const google = window.google;
		const mapInstance = new google.maps.Map(mapRef.current, {
			center: { lat: 28.524782, lng: 77.277073 },  // Default center
			zoom: 12,
			scrollwheel: false,
		});

		// Set up the autocomplete service on the input box
		if(!readOnly){
		autocompleteRef.current = new google.maps.places.Autocomplete(document.getElementById("location-input"), {
			types: ["geocode", "establishment"],   // You can adjust this if you want more than just geocodes
		});

		autocompleteRef.current.setFields(["place_id", "geometry", "name"]);

		autocompleteRef.current.addListener("place_changed", () => {
			const place = autocompleteRef.current.getPlace();
			handlePlaceSelection(place, mapInstance);
		});
		}

		// Set up DrawingManager
		let drawingManagerInstance = null;
		if (!readOnly) {
			drawingManagerInstance = new google.maps.drawing.DrawingManager({
			drawingMode: google.maps.drawing.OverlayType.POLYGON,
			drawingControl: true,
			drawingControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER,
				drawingModes: [google.maps.drawing.OverlayType.POLYGON],
			},
			polygonOptions: {
				editable: true,
				draggable: true,
			},
		});
		drawingManagerInstance.setMap(mapInstance);
		google.maps.event.addListener(drawingManagerInstance, "overlaycomplete", (event) => {
			if (event.type === "polygon") {
				handlePolygonComplete(event, mapInstance);
			}
		});
	}

			setMap(mapInstance);
			setDrawingManager(drawingManagerInstance);

			// If initial coordinates are provided, create the polygon
			if (initialCoordinates.length > 0) {
						initializePolygon(initialCoordinates, mapInstance, drawingManagerInstance);
			}
		};
	const handlePlaceSelection = (place, mapInstance) => {
		if (readOnly) return;
		if (place && place.geometry) {
			mapInstance.setCenter(place.geometry.location);
			mapInstance.setZoom(15);

			if (markerRef.current) {
				markerRef.current.setMap(null);
			}

			const marker = new google.maps.Marker({
				position: place.geometry.location,
				map: mapInstance,
				title: place.name,
			});

			markerRef.current = marker;
			setLocation(place.formatted_address || place.name);
		}
	};

	const initializePolygon = (coordinates, mapInstance, drawingManagerInstance) => {
		setFactoryCoordinates(coordinates);
			const polygon = new google.maps.Polygon({
				paths: coordinates.map((coord) => ({ lat: coord.lat, lng: coord.lng })),
				editable: !readOnly,
				draggable: !readOnly,
				map: mapInstance,
			});

			currentPolygonRef.current = polygon;
			if (!readOnly) {
				drawingManagerInstance?.setDrawingMode(null);

				google.maps.event.addListener(polygon.getPath(), "set_at", updateCoordinates);
				google.maps.event.addListener(polygon.getPath(), "insert_at", updateCoordinates);
			}
			const bounds = new google.maps.LatLngBounds();
			polygon.getPath().forEach((latLng) => bounds.extend(latLng));
			mapInstance.fitBounds(bounds);

			function updateCoordinates() {
				const coordinates = polygon
					.getPath()
					.getArray()
					.map((latLng) => ({
						lat: latLng.lat(),
						lng: latLng.lng(),
					}));
				setFactoryCoordinates(coordinates);
				onCoordinatesChange(coordinates);
			}
		}

	const handlePolygonComplete = (event, mapInstance) => {
		if (readOnly) return;
		if (currentPolygonRef.current) {
			currentPolygonRef.current.setMap(null);
		}

		const polygon = event.overlay;
		currentPolygonRef.current = polygon;

		google.maps.event.addListener(polygon.getPath(), "set_at", updateCoordinates);
		google.maps.event.addListener(polygon.getPath(), "insert_at", updateCoordinates);

		updateCoordinates();

		function updateCoordinates() {
			const coordinates = polygon
				.getPath()
				.getArray()
				.map((latLng) => ({
					lat: latLng.lat(),
					lng: latLng.lng(),
				}));
			setFactoryCoordinates(coordinates);
			onCoordinatesChange(coordinates);
		}
	};

	const clearGeofence = () => {
		if (readOnly) return;
		// Remove the polygon from the map but keep the location marker
		if (currentPolygonRef.current) {
			currentPolygonRef.current.setMap(null);
			currentPolygonRef.current = null;  // Reset the polygon reference
		}

		setFactoryCoordinates([]);
	};

    const validateCoOrdinates = () => {
    const errors = {};
    let success = true;
    const lat = parseFloat(latLngInput.lat);
    const lng = parseFloat(latLngInput.lng);

    if (isNaN(lat)) {
        errors.latitude = "Enter valid latitude values";
        success = false;
    } else if (lat < -90 || lat > 90) {
        errors.latitude = "Latitude must be between -90 and 90";
        success = false;
    }

    if (isNaN(lng)) {
        errors.longitude = "Enter valid longitude values";
        success = false;
    } else if (lng < -180 || lng > 180) {
        errors.longitude = "Longitude must be between -180 and 180";
        success = false;
    }
    return { errors, success };
};

const handleSearchByCoordinates = () => {
    if (!map) return;
    
    const validation = validateCoOrdinates();
    if (!validation.success) {
        setErrors(validation.errors);
        return;
    }

    const lat = parseFloat(latLngInput.lat);
    const lng = parseFloat(latLngInput.lng);
    
    const location = new window.google.maps.LatLng(lat, lng);
    map.setCenter(location);
    map.setZoom(15);

    if (markerRef.current) {
        markerRef.current.setMap(null);
    }

    const marker = new window.google.maps.Marker({
        position: location,
        map: map,
    });

    markerRef.current = marker;
    setErrors({});
};

	useEffect(() => {
		if (window.google && window.google.maps && window.google.maps.places) {
			initMap();
		} else {
			const checkGoogleMapsLoaded = setInterval(() => {
				if (window.google && window.google.maps && window.google.maps.places) {
					clearInterval(checkGoogleMapsLoaded);
					initMap();
				}
			}, 100);
			return () => clearInterval(checkGoogleMapsLoaded);
		}
	}, []);

	return (
		<div className="geofence-container">
			{noExtraField ? null :
			<div className="location-search">
				<div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.5rem",flexWrap: "wrap"}}>
					<div style={{ flex: 0.5, minWidth: "250px" }}>
						<Input
							id="location-input"
							label="Search by place name"
							type="text"
							value={location}
							onChange={(e) => setLocation(e.target.value)}
							sx={{ width: "100%" }}
						/>
					</div>
					<div style={{ color: "#666", padding: "0 0.5rem", marginBottom: "0.5rem"}}> OR </div>				
					<div style={{ display: "flex", gap: "0.5rem", minWidth: "200px"}}>
						<Input
							label="Latitude"
                            name="latitude"
							type="text"
							value={latLngInput.lat}
							onChange={(e) => setLatLngInput({ ...latLngInput, lat: e.target.value })}
							placeholder="e.g. 28.524782"
                            error={errors.latitude}
						/>
						<Input
							label="Longitude"
                            name="longitude"
							type="text"
							value={latLngInput.lng}
							onChange={(e) => setLatLngInput({ ...latLngInput, lng: e.target.value })}
							placeholder="e.g. 77.277073"
                            error={errors.longitude}
						/>
						<Button text="Search" style={{ ...buttonClasses.lynkitOrangeFill, maxWidth:'120px', maxHeight:"35px"} } onClick={handleSearchByCoordinates} />
					</div>
				</div>
			</div>
			}
			<div style={{ position: "relative" }}>
				<div ref={mapRef} className="map" style={{ height: "500px", width: "100%" }}></div>
				<div className="controls">
					<button type="button" onClick={clearGeofence} className="clear-button">
						Clear Geofence
					</button>
				</div>
			</div>

			{factoryCoordinates.length > 0 && (
				<div className="coordinate_container">
					<h6>Factories Co-ordinates</h6>
					<div className="coordinate_box">
						{factoryCoordinates.map((coordinate, index) => (
							<div key={index}>
								<ul>
									<li>
										<div>Latitude: {coordinate.lat}</div>
										<div>Longitude: {coordinate.lng}</div>
									</li>
								</ul>
							</div>
						))}
					</div>
				</div>
			)}
		</div>
	);
};

export default Geofence;
